import { Box } from "@mui/material";
import { Map } from "@vis.gl/react-google-maps";

const MapView = ({ longitude, latitude, height, width }) => {
  return (
    <Box sx={{ height, width }}>
      <Map
        defaultZoom={13}
        defaultCenter={{ lat: latitude, lng: longitude }}
        onCameraChanged={(ev) =>
          console.log(
            "camera changed:",
            ev.detail.center,
            "zoom:",
            ev.detail.zoom
          )
        }
      />
    </Box>
  );
};

export default MapView;
